import { render, staticRenderFns } from "./InfoFlow.vue?vue&type=template&id=a070bba4&scoped=true&"
import script from "./InfoFlow.vue?vue&type=script&lang=js&"
export * from "./InfoFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a070bba4",
  null
  
)

export default component.exports